import React from "react";

function CapitalizationRule({
  id,
  checked,
  onChange,
  label = "Answers must start with a capital letter",
}) {
  return (
    <div className="flex items-center gap-2 mt-2">
      <input
        id={id}
        type="checkbox"
        checked={Boolean(checked)}
        onChange={(e) => onChange(e.target.checked)}
        className="w-4 h-4 rounded border-gray-300 text-green-600 focus:ring-green-500"
      />
      <label
        htmlFor={id}
        className="text-sm cursor-pointer select-none"
      >
        {label}
      </label>
    </div>
  );
}

export default CapitalizationRule;
